import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.HelpStripe', {
    knowledgeBaseActivator: 'Knowledge base',
    videosActivator: 'How-to videos',
    trainingActivator: 'Setup and training package',
    hideButton: 'Hide',
});
